import ApiService from "@/services/api.service"

/// *** Log Service *** ///

export const LogService = {
  sendLog(params) { // this one for logging in file
    return ApiService.post(`logs/create`, params, {}, { loader: false })
  },
  sendActivityLog(params) { // this one for logging in activity_log table
    return ApiService.post(`logs/activity/create`, params, {}, { loader: false })
  }
}
